import styled from 'styled-components';

export const Author = styled.div`
  opacity: 0.75;
`;
